// extracted by mini-css-extract-plugin
export default {"container":"NotificationBoard_container__HYh9Z","card":"NotificationBoard_card__-YmvB","card-on":"NotificationBoard_card-on__HXt7Z","dialog":"NotificationBoard_dialog__u5KVL"};